import { render } from "./Empty.vue?vue&type=template&id=56ce5abf"
const script = {}
script.render = render

export default script